export const iconFontAwesomeConstructionCompassDrafting = (
	<i className="fa-solid fa-compass-drafting"></i>
);
